var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBug(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgba(21,27,38,.75)",
    viewBox: "0 0 24 24",
    title: "bug",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MultiColorIcon-path--fadedBlack",
    d: "M5.1,9.9c-1-1.1-1.8-2.6-2-4.1C3,5.3,2.6,4.9,2.1,4.9C1.5,4.9,1,5.4,1.1,6c0.3,2.7,1.8,5,3.9,6.4L5,13h14v-0.6 c2.1-1.4,3.6-3.7,3.9-6.4c0.1-0.6-0.4-1.1-1-1.1c-0.5,0-0.9,0.4-1,0.9c-0.2,1.5-0.9,2.9-1.9,4c-0.2-1.5-1-2.9-2-3.9 c-0.5-0.4-1.1-0.8-1.7-1.2c1-0.4,1.7-1.3,1.7-2.5V0.9C17,0.4,16.5,0,16,0s-1,0.4-1,0.9v0.7c0,0.3-0.1,0.7-0.3,0.9 c-0.5-1-1.5-1.6-2.7-1.6S9.8,1.5,9.3,2.5C9.1,2.3,9,1.9,9,1.6V0.9C9,0.4,8.5,0,8,0S7,0.4,7,0.9v1.3c0,1.2,0.7,2.2,1.8,2.5 C6.8,5.7,5.4,7.6,5.1,9.9z M1.1,22.8c0.3-2.7,1.8-5.5,3.9-6.9l0,0V17c0,0.6,0.1,1.2,0.2,1.8c-1.1,1.1-1.9,2.6-2.1,4.2 c-0.1,0.5-0.5,0.9-1,0.9C1.5,23.9,1,23.4,1.1,22.8z M18.8,18.8c1.2,1.1,2,2.6,2.2,4.3c0.1,0.5,0.5,0.9,1,0.9s1-0.4,1-1v-0.2 c-0.3-2.7-1.9-5.5-4-6.9V17C19,17.6,18.9,18.2,18.8,18.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "MultiColorIcon-path--white",
    d: "M12,24c-3.9,0-7-3.1-7-7v-4h14v4C19,20.9,15.9,24,12,24z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBug);
export default __webpack_public_path__ + "static/media/bug.70f0d049.svg";
export { ForwardRef as ReactComponent };